/**
 * `code` value of the backend's capability 403 body (Graph-only feature denied for a
 * tokenless external viewer) — mirrors `constants/capabilityConstants.js` server-side.
 */ var CAPABILITY_DENIAL_CODE = 'CAPABILITY_UNAVAILABLE';
var LOGIN_ERROR_CODES = /*#__PURE__*/ function(LOGIN_ERROR_CODES) {
    LOGIN_ERROR_CODES[LOGIN_ERROR_CODES["EXPECTED_ERROR"] = -1] = "EXPECTED_ERROR";
    LOGIN_ERROR_CODES[LOGIN_ERROR_CODES["REGION_FUNCTION_ERROR"] = 1000] = "REGION_FUNCTION_ERROR";
    LOGIN_ERROR_CODES[LOGIN_ERROR_CODES["GENERIC_GRAPH_ERROR"] = 1001] = "GENERIC_GRAPH_ERROR";
    LOGIN_ERROR_CODES[LOGIN_ERROR_CODES["INVALID_ID_TOKEN"] = 1002] = "INVALID_ID_TOKEN";
    LOGIN_ERROR_CODES[LOGIN_ERROR_CODES["CAN_NOT_GET_ACCESS_TOKEN"] = 1003] = "CAN_NOT_GET_ACCESS_TOKEN";
    LOGIN_ERROR_CODES[LOGIN_ERROR_CODES["SSO_USER_NOT_FOUND"] = 1004] = "SSO_USER_NOT_FOUND";
    LOGIN_ERROR_CODES[LOGIN_ERROR_CODES["GENERIC_ERROR"] = 1005] = "GENERIC_ERROR";
    LOGIN_ERROR_CODES[LOGIN_ERROR_CODES["ID_TOKEN_NOT_FOUND"] = 1006] = "ID_TOKEN_NOT_FOUND";
    LOGIN_ERROR_CODES[LOGIN_ERROR_CODES["CODE_NOT_EXISTS"] = 1007] = "CODE_NOT_EXISTS";
    return LOGIN_ERROR_CODES;
}(LOGIN_ERROR_CODES || {});
/**
 * Business-expected login failure reasons.
 */ var EXPECTED_LOGIN_ERROR_REASONS = /*#__PURE__*/ function(EXPECTED_LOGIN_ERROR_REASONS) {
    EXPECTED_LOGIN_ERROR_REASONS["TRIAL_EXPIRED"] = "trialExpired";
    EXPECTED_LOGIN_ERROR_REASONS["QUOTA_EXCEEDED"] = "quotaExceeded";
    EXPECTED_LOGIN_ERROR_REASONS["QUOTA_EXCEEDED_PAID"] = "quotaExceededPaid";
    EXPECTED_LOGIN_ERROR_REASONS["LICENSE_EXPIRED"] = "licenseExpired";
    EXPECTED_LOGIN_ERROR_REASONS["SUBSCRIPTION_CANCELED"] = "subscriptionCanceled";
    EXPECTED_LOGIN_ERROR_REASONS["SUBSCRIPTION_SUSPENDED"] = "subscriptionSuspended";
    EXPECTED_LOGIN_ERROR_REASONS["NOT_ALLOWED_USER"] = "notAllowedUser";
    EXPECTED_LOGIN_ERROR_REASONS["BLOCKED_USER"] = "blockedUser";
    return EXPECTED_LOGIN_ERROR_REASONS;
}(EXPECTED_LOGIN_ERROR_REASONS || {});
var IMPERSONATION_ERROR_CODES = /*#__PURE__*/ function(IMPERSONATION_ERROR_CODES) {
    IMPERSONATION_ERROR_CODES["TARGET_SESSION_EXPIRED"] = "IMPERSONATION_TARGET_SESSION_EXPIRED";
    return IMPERSONATION_ERROR_CODES;
}(IMPERSONATION_ERROR_CODES || {});
export { LOGIN_ERROR_CODES, EXPECTED_LOGIN_ERROR_REASONS, CAPABILITY_DENIAL_CODE, IMPERSONATION_ERROR_CODES };
